<template>
  <Teleport to="body">
    <div
      v-if="toasts.length > 0"
      class="fixed z-50 pointer-events-none"
      :class="containerClasses"
    >
      <div class="space-y-2 pointer-events-auto">
        <Toast
          v-for="toast in toasts"
          :key="toast.id"
          :id="toast.id"
          :type="toast.type"
          :title="toast.title"
          :description="toast.description"
          :duration="toast.duration"
          :closable="toast.closable"
          :show-progress="toast.showProgress"
          :position="position"
          @close="handleClose"
        />
      </div>
    </div>
  </Teleport>
</template>

<script>
import { computed } from 'vue'
import { useToast } from '../../utils/toast.js'
import Toast from './toast.vue'

export default {
  name: 'ToastContainer',
  components: {
    Toast
  },
  props: {
    position: {
      type: String,
      default: 'top-right',
      validator: (value) => ['top-left', 'top-right', 'bottom-left', 'bottom-right'].includes(value)
    }
  },
  setup(props, { emit }) {
    const { toasts, removeToast } = useToast()

    const containerClasses = computed(() => {
      const positions = {
        'top-left': 'top-4 left-4',
        'top-right': 'top-4 right-4',
        'bottom-left': 'bottom-4 left-4',
        'bottom-right': 'bottom-4 right-4'
      }
      return positions[props.position] || positions['top-right']
    })

    const handleClose = (id) => {
      removeToast(id)
      emit('toast-close', id)
    }

    return {
      toasts,
      containerClasses,
      handleClose
    }
  }
}
</script>
